<template>
  <div>
    <AuthTokensHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeTab="(data) => $emit('changeTab', data)"
        @reload="$emit('reload')"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <AuthTokensFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <AuthTokensTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @reload="$emit('reload')"
          @updateItem="(id, status) => {$emit('updateItem', id, status)}"
      />
    </div>
  </div>
</template>

<script>


  import AuthTokensHead from "./AuthTokensHead/AuthTokensHead";
  import AuthTokensFilter from "./AuthTokensFilter/AuthTokensFilter";
  import AuthTokensTable from "./AuthTokensTable/AuthTokensTable";

  export default {
    name: "AuthTokensTableUser",

    components: {
      AuthTokensHead,
      AuthTokensFilter,
      AuthTokensTable,
    },

    props: {
      typeShops: String,
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    watch: {
      filterGetParams(newVal) {
        this.filterGetParams = newVal
      },
      countFilterParams(newVal) {
        this.countFilterParams = newVal
      },
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
